export default "__VITE_ASSET__Dx93_xTu__"